import React from 'react';
import { FiDollarSign } from 'react-icons/fi';

/**
 * MoneyIcon
 * Ikona meny na označenie sekcií správy platieb a finančných údajov.
 */
const MoneyIcon = ({ className = 'inline-block align-middle', ...props }) => (
  <FiDollarSign className={className} {...props} />
);

export default MoneyIcon;

